import { Pipe, PipeTransform } from '@angular/core';

import { PhonePipeOptionsModel } from './typings/phone-pipe.options';
import { SessionService }        from '../../sessions/session.service';

@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {
  public _defaultOptions : PhonePipeOptionsModel = {
    html: true
  };

  constructor(
    public sessionService: SessionService
  ) {}

  format ( value : string, mask : string, regexObj : RegExp, options : PhonePipeOptionsModel = this._defaultOptions ) : string {
    if ( !value ) {
      return '';
    }
    else if ( value.match(regexObj) ) {
      return value.replace(regexObj, mask);
    }
    else {
      return options.html
        ? `<span class="text-danger">${value}</span>`
        : value;
    }
  }

  transform ( value : string, options : PhonePipeOptionsModel = this._defaultOptions ) : string {
    const country    = this.sessionService.countryValidation();
    const mask       = country.phone.mask;
    const validation = country.phone.validation;

    const regexObj = new RegExp(validation);

    return this.format(value, mask, regexObj, options);
  }
}

